import Highcharts from "highcharts";
import {
  chartBackgroundColor,
  gridLineColor,
  lineColor,
  primaryGraphColor,
  labelTextOverflow,
  xAxisTickWidth,
  plotOptionsBarBorderColor,
  plotOptionsBarBorderWidth,
  plotOptionsBarShowInLegend,
  plotOptionsBarThreshold,
  barChartBorderRadius,
} from "./globals";

document.addEventListener("turbo:load", () => {
  const charts: NodeListOf<HTMLElement> = document.querySelectorAll(
    "[data-chart='level_and_process']",
  );

  if (charts) {
    Array.from(charts).forEach((chart) => {
      const domainNames: string[] = JSON.parse(chart.dataset.domainNames!);
      const processPercentages: number[] = JSON.parse(
        chart.dataset.processPercentages!,
      );
      const practicePercentages: number[] = JSON.parse(
        chart.dataset.practicePercentages!,
      );

      Highcharts.chart({
        chart: {
          renderTo: chart,
          backgroundColor: chartBackgroundColor,
          height: "300px",
        },
        title: {
          margin: 35,
          text: "PRACTICE AND PROCESS LEVEL RESULTS BY DOMAIN",
          style: {
            fontWeight: "bold",
          },
        },
        xAxis: [
          {
            lineWidth: 1,
            labels: {
              style: {
                fontSize: "12px",
                fontWeight: "bold",
                color: primaryGraphColor,
                textOverflow: labelTextOverflow,
              },
            },
            lineColor: lineColor,
            tickColor: lineColor,
            categories: domainNames,
            tickWidth: xAxisTickWidth,
          },
        ],
        yAxis: [
          {
            gridLineWidth: 1,
            gridLineColor: gridLineColor,
            tickPositions: [0, 25, 50, 75, 100],
            title: {
              text: undefined,
            },
            labels: {
              format: "{value}%",
              style: {
                fontSize: "14px",
                fontWeight: "bold",
              },
            },
          },
        ],
        tooltip: {
          enabled: true,
          headerFormat: "<b>{point.key}</b><br>",
          pointFormat: "{series.name}: {point.y}%",
        },
        plotOptions: {
          column: {
            animation: false,
            borderColor: plotOptionsBarBorderColor,
            borderWidth: plotOptionsBarBorderWidth,
            borderRadius: barChartBorderRadius,
            showInLegend: plotOptionsBarShowInLegend,
            threshold: plotOptionsBarThreshold,
            groupPadding: 0.07,
          },
        },
        series: [
          {
            type: "column",
            name: "Process",
            showInLegend: false,
            animation: false,
            color: "#9FC1CD",
            data: practicePercentages,
          },
          {
            type: "line",
            name: "Practice",
            showInLegend: false,
            animation: false,
            color: "#16556A",
            data: processPercentages,
          },
        ],
      });
    });
  }
});
